import { PromptModal } from "_components/Abstractions/PromptModal";
import { useToast } from "_helpers/notifications/useToasts";
import { wastesActions } from "_store/wastes.slice";
import { useDispatch, useSelector } from "react-redux";

export function ChangeWasteState({ waste }) {
  const dispatch = useDispatch();
  const { wastesPaging } = useSelector((x) => x.wastes);
  const { internalName, wasteId, isDeleted } = waste;
  const { showSuccessMessage, showErrorMessage } = useToast();

  async function onSubmit(promptResult) {
    if (promptResult !== "Yes") {
      return;
    }

    const changeStatusAction = isDeleted ? wastesActions.activate : wastesActions.deactivate;
    const response = await dispatch(changeStatusAction({ wasteId }));

    if (!response.error) {
      // const pageNumber = wastesPaging?.pageNumber ?? 1;
      // dispatch(wastesActions.getAll({ pageNumber }));
      showSuccessMessage("Zaktualizowano towar");
    } else {
      showErrorMessage(response.error?.message);
    }
  }

  return (
    <>
      <PromptModal
        buttonText={isDeleted ? "Aktywuj" : "Dezaktywuj"}
        title={`Czy chcesz zaktualizować towar (${internalName})?`}
        type="YesNo"
        onSubmit={onSubmit}
      />
    </>
  );
}
